var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex items-center justify-between flex-wrap p-4 bg-surface"},[_c('div',{staticClass:"flex items-center flex-no-shrink mr-6"},[_c('logo')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }